<div class="pdf-page app-aul-025-24" id="aul02524">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> LAND, WATER AND AIR EXCLUSION </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    Notwithstanding any provision to the contrary within the Policy of which
    this Endorsement forms part (or within any other Endorsement which forms
    part of this Policy), this Policy does not insure land (including but not
    limited to land on which the insured property is located), water or air,
    howsoever and wherever occurring, or any interest or right therein.
  </p>
</div>
